export const TOASTER_ACTIONS = {
  SET_NEW_TOASTER_DATA: "SET_NEW_TOASTER_DATA",
  RESET_NEW_TOASTER_DATA: "RESET_NEW_TOASTER_DATA",
};
